import { ConfigProvider, theme } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

const themeConfig = {
  algorithm: theme.defaultAlgorithm, // Add this to apply custom themes
  token: {
    colorPrimary: "#cb1b5b",
    borderRadius: 4,
    fontSize: 16,
    colorBgBase: "#f0f2f5",
    colorBgContainer: "#ffffff",
  },
  components: {
    Button: {
      colorPrimary: "#cb1b5b",
      borderRadius: 6,
      colorText: "#4D4D4D",
    },
    Input: {
      colorPrimary: "#cb1b5b",
      colorBorder: "#d9d9d9",
      borderRadius: 4,
      colorText: "#4D4D4D",
    },
    Card: {
      colorBgContainer: "#ffffff",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ConfigProvider theme={themeConfig}>
      <App />
    </ConfigProvider>
  </BrowserRouter>,
);

reportWebVitals();
